import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 10 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 17\" id=\"icon-slider--left\"><path d=\"m8.942 15.763-7-7.031 7-7.032\" stroke=\"currentColor\" stroke-width=\"2.5\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol